import {
	CustomersContext,
	ICustomersContext,
} from 'modules/CustomersAndRestaurants/Customers/Customers/customersState/customersContext';
import React, { useContext, useEffect } from 'react';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../customerFullInfoState/customerFullInfoContext';
import { MainInfoTab } from './components/MainInfoTab/MainInfoTab';
import LocalizationTab from './components/LocalizationTab/LocalizationTab';
import StyleTab from './components/StyleTab/StyleTab';
import SoftwareTab from './components/SoftwareTab/SoftwareTab';
import { BpaTab } from './components/BpaTab/BpaTab';

const Tabs: React.FC = () => {
	const { fullInfoData } = useContext<ICustomersContext>(CustomersContext);
	const { changeCustomerFullInfoVisibleForm, customerFullInfoVisibleForm } =
		useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	useEffect(() => {
		fullInfoData.activeTab && changeCustomerFullInfoVisibleForm(fullInfoData.activeTab);
	}, [fullInfoData.activeTab]);

	const getTab = () => {
		switch (customerFullInfoVisibleForm) {
			case 'mainForm':
				return <MainInfoTab />;
			case 'localizationForm':
				return <LocalizationTab />;
			case 'styleForm':
				return <StyleTab />;
			case 'softwareForm':
				return <SoftwareTab />;
			case 'bpaForm':
				return <BpaTab />;
			default:
				return null;
		}
	};

	return <div data-test="Tabs">{getTab()}</div>;
};

export default Tabs;
